import React from "react";
import MaskedInput from 'react-text-mask';

export const MASCARA_NUMERO_ETIQUETA = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
const MASCARA_CPF = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

export const criarCampoComMascara = (id, regexArray) => {
    
    return (props) => {
        const { inputRef, ...other } = props;
        const refFunc = (input) => inputRef(input?.inputElement);

        return (
            <MaskedInput
                id={id}
                mask={regexArray}
                guide={false}
                ref={refFunc}
                {...other}
            />
        );
    };
};

export const criarCampoComMascaraCPF = (id) => criarCampoComMascara(id, MASCARA_CPF);